(ns minorodata.ai-chat.confirmation
  (:require [clojure.string :as string]))


(def ^:private labels
  {"rename_tag_tool" "Rename tag"
   "delete_tag_tool" "Delete tag"
   "merge_tags_tool" "Merge tags"})


(defn action-label [action]
  (let [action (str action)]
    (cond
      (string/blank? action) "Confirm action"
      (labels action)        (labels action)
      :else                  (-> action
                                 (string/replace #"_tool$" "")
                                 (string/replace "_" " ")
                                 string/capitalize))))


(defn renderable? [message]
  (and (= "confirmation_request" (:type message))
       (string? (:id message))
       (not (string/blank? (:id message)))))


(defn pending? [message]
  (and (renderable? message)
       (nil? (:answer message))))


(defn answer-payload [base id confirmed?]
  (assoc base "confirmation" {"id" id "confirmed" (boolean confirmed?)}))


(defn mark-answered [messages id answer]
  (mapv (fn [message]
          (if (and (= "confirmation_request" (:type message))
                   (= id (:id message))
                   (or (nil? (:answer message))
                       (and (= :failed answer) (= :confirmed (:answer message)))))
            (assoc message :answer answer)
            message))
        messages))


(defn supersede-pending [messages]
  (mapv (fn [message]
          (if (pending? message)
            (assoc message :answer :superseded)
            message))
        messages))


(defn status-text [answer]
  (case answer
    :confirmed  "You pressed Confirm."
    :cancelled  "You pressed Cancel."
    :superseded "Replaced by a newer message."
    :failed     "The connection to KAI dropped. Ask KAI whether the change went through."
    nil))
